import { render, staticRenderFns } from "./micro-course-card.vue?vue&type=template&id=b0fe0136&"
import script from "./micro-course-card.vue?vue&type=script&lang=js&"
export * from "./micro-course-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports